import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { TranslationService } from "../../services/TranslationService";
import PortalClientService from "../../services/PortalClientService";
import Loading from "./components/Loading";
import { isExpiredToken } from "../../utils/FuncUtils";
import { jwtDecode } from "jwt-decode";
import { UserPayload } from "../../entities/login/UserPayload";

export const PortalSiteHashValidator = () => {
  const history = useHistory();
  const hashToken = new URLSearchParams(history.location.search).get("h") ?? "";

  useEffect(() => {
    const validateHashToken = async (token: string) => {
      const result = await PortalClientService.getTokenByHash({ hash: token });
      if (result instanceof Error) {
        window.location.href = `${window.location.origin}/${TranslationService.currentLanguage}/page-not-found?msg=ErrorProcessingRequest`;
        return;
      } else {
        try {
          const tokenResult = result?.data.token || hashToken || "notoken";
          const tokenPayload: UserPayload = jwtDecode(tokenResult);
          const isExpired = isExpiredToken(tokenPayload.exp);
          if (isExpired) {
            window.location.href = `${window.location.origin}/${TranslationService.currentLanguage}/page-not-found?msg=SessionExpired`;
            return;
          }

          window.location.href =
            `${window.location.origin}/${TranslationService.currentLanguage}/portalclient?t=` +
            tokenResult;
          return;
        } catch (error) {
          window.location.href = `${window.location.origin}/${TranslationService.currentLanguage}/page-not-found?msg=ErrorProcessingRequest`;
          return;
        }
      }
    };
    validateHashToken(hashToken);
  }, [hashToken]);

  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100vh", minHeight: "100%" }}
    >
      <Loading />
    </div>
  );
};
